import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const KEY = "othryx.cookie.consent";

export default function CookieBanner() {
    const { t } = useLang();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const saved = window.localStorage.getItem(KEY);
        if (!saved) {
            const id = window.setTimeout(() => setShow(true), 700);
            return () => window.clearTimeout(id);
        }
    }, []);

    const decide = (value) => {
        window.localStorage.setItem(KEY, value);
        setShow(false);
    };

    if (!show) return null;

    return (
        <div
            data-testid="cookie-banner"
            role="dialog"
            aria-label="Cookie consent"
            className="fixed bottom-4 inset-x-4 lg:inset-x-auto lg:end-6 lg:start-6 z-50"
        >
            <div className="mx-auto max-w-3xl bg-navy-dark text-white border border-white/10 shadow-2xl shadow-black/30 p-5 lg:p-6 flex flex-col lg:flex-row lg:items-center gap-4">
                <div className="flex-1 text-sm leading-relaxed text-steel-200">
                    <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/80 me-2">
                        Cookies
                    </span>
                    {t.cookie.text}
                </div>
                <div className="flex items-center gap-2 lg:flex-shrink-0">
                    <button
                        onClick={() => decide("declined")}
                        data-testid="cookie-decline"
                        className="font-mono-tech text-[11px] uppercase tracking-[0.2em] px-4 py-2.5 border border-white/30 text-white hover:bg-white/10 transition"
                    >
                        {t.cookie.decline}
                    </button>
                    <button
                        onClick={() => decide("accepted")}
                        data-testid="cookie-accept"
                        className="font-mono-tech text-[11px] uppercase tracking-[0.2em] px-4 py-2.5 bg-white text-navy hover:bg-steel-100 transition"
                    >
                        {t.cookie.accept}
                    </button>
                    <button
                        onClick={() => decide("dismissed")}
                        data-testid="cookie-close"
                        aria-label="Close"
                        className="text-white/70 hover:text-white p-1"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
